
import Vue, { PropOptions } from 'vue'
import { FeatureItem } from '~/types'

export default Vue.extend({
  props: {
    items: {
      type: Array,
      required: false,
      default: () => [],
    } as PropOptions<FeatureItem[]>,
  },
})
